var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 342.53 363.53",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#444;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M302.39,26.76H286.33V13.38A13.38,13.38,0,0,0,273,0h0a13.38,13.38,0,0,0-13.38,13.38V26.76H83V13.38A13.38,13.38,0,0,0,69.58,0h0A13.38,13.38,0,0,0,56.2,13.38V26.76H40.14A40.14,40.14,0,0,0,0,66.9V323.39a40.14,40.14,0,0,0,40.14,40.14H302.39a40.14,40.14,0,0,0,40.14-40.14V66.9A40.14,40.14,0,0,0,302.39,26.76Zm13.38,296.63a13.39,13.39,0,0,1-13.38,13.38H40.14a13.39,13.39,0,0,1-13.38-13.38V146.77h289Zm0-203.38h-289V66.9A13.38,13.38,0,0,1,40.14,53.52H56.2V66.9A13.38,13.38,0,0,0,69.58,80.28h0A13.38,13.38,0,0,0,83,66.9V53.52H259.57V66.9A13.38,13.38,0,0,0,273,80.28h0A13.38,13.38,0,0,0,286.33,66.9V53.52h16.06A13.38,13.38,0,0,1,315.77,66.9Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 50.84,
    y: 174.87,
    width: 26.76,
    height: 26.76
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 104.36,
    y: 174.87,
    width: 26.76,
    height: 26.76
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 157.89,
    y: 174.87,
    width: 26.76,
    height: 26.76
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 211.41,
    y: 174.87,
    width: 26.76,
    height: 26.76
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 264.93,
    y: 174.87,
    width: 26.76,
    height: 26.76
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 50.84,
    y: 228.39,
    width: 26.76,
    height: 26.76
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 104.36,
    y: 228.39,
    width: 26.76,
    height: 26.76
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 157.89,
    y: 228.39,
    width: 26.76,
    height: 26.76
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 211.41,
    y: 228.39,
    width: 26.76,
    height: 26.76
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 50.84,
    y: 281.91,
    width: 26.76,
    height: 26.76
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 104.36,
    y: 281.91,
    width: 26.76,
    height: 26.76
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 157.89,
    y: 281.91,
    width: 26.76,
    height: 26.76
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 211.41,
    y: 281.91,
    width: 26.76,
    height: 26.76
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 264.93,
    y: 228.39,
    width: 26.76,
    height: 26.76
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.9d240796660c1fc5d1786659198157e7.svg";
export { ForwardRef as ReactComponent };